export default function ErrorPage() {
    return (
        <div >
            Essa rota não existe!
        </div>
    )
}